module.exports = __webpack_public_path__ + "img/card_v2.33da209.png";